import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

type Props = {
  notSaved: boolean;
};

const CONFIRMATION_MESSAGE = 'Changes you made may not be saved.';

const usePreventUnsaved = (props: Props) => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      props.notSaved && currentLocation.pathname !== nextLocation.pathname,
  );

  useEffect(() => {
    if (blocker.state === 'blocked') {
      const result = confirm(CONFIRMATION_MESSAGE);
      if (result) {
        blocker.proceed();
      } else {
        blocker.reset();
      }
    }
  }, [blocker]);

  useEffect(() => {
    const beforeUnloadHandler = (e: BeforeUnloadEvent) => {
      (e || window.event).returnValue = CONFIRMATION_MESSAGE;
      return CONFIRMATION_MESSAGE;
    };

    if (props.notSaved) {
      window.addEventListener('beforeunload', beforeUnloadHandler);
    } else {
      window.removeEventListener('beforeunload', beforeUnloadHandler);
    }
    return () => {
      window.removeEventListener('beforeunload', beforeUnloadHandler);
    };
  }, [props.notSaved]);
};

export default usePreventUnsaved;
